//Mui Imports
import { styled } from '@mui/material'
import Button from '@mui/material/Button'

const DialogCloseButton = styled(Button)(({ theme }) => ({
    top: 0,
    right: 0,
    position: 'absolute',
    padding: 0,
    blockSize: 30,
    inlineSize: 30,
    minInlineSize: 0,
    borderRadius: theme.shape.borderRadius?.sm ?? theme.shape.borderRadius,
    color: theme.palette.text.disabled,
    backgroundColor: `${theme.palette.background.paper} !important`,
    boxShadow: theme.customShadows?.xs ?? 'none',
    transform: 'translate(9px, -10px)',
    transition: 'transform 0.25s ease-in-out, box-shadow 0.25s ease-in-out',
  
    '&:hover, &:active': {
      transform: 'translate(7px, -5px) !important'
    },
  
    '& svg': {
      fontSize: '1.25rem'
    }
  }))

export default DialogCloseButton
